module.exports = __webpack_public_path__ + "static/media/ios-volume-off.287ed219.svg";